export const RenderWhenMatch = ({match, children}) => {
    if(match) {
        return children
    } else {
        return null
    }
}